<template>
  <div class="pop-dim">
    <div class="pop-wrap">
      <h2>오류발생</h2>
      <p>
        오류가 발생하였습니다. 잠시 후 다시 시도해 주세요.
        <br>계속해서 오류가 발생한다면 문의주시기 바랍니다.
      </p>
      <button-item :btnText="'확인'" :btnClass="'layerpop-btn'" @click="onCancel"/>
      <div class="pop-close"></div>
    </div>
  </div>
</template>

<script>
import ButtonItem from '@/components/ui/button'

export default {
  name: 'Error500',
  props: {
    type: {
      type: String,
      default: 'delete' // delete, stop, confirm
    }
  },
  components: {
    ButtonItem
  },
  destroyed () {
    this.$close(false)
  },
  methods: {
    onCancel () {
      this.$close(false)
    },
    onSubmit () {
      this.$close(true)
    }
  }
}
</script>

<style lang="scss" scoped>
.pop-wrap {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  width: 430px;
  height: 295px;
  border-radius: 14px;
  box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.16);
  background-color: #fff;
  text-align: center;
  box-sizing: border-box;
  padding: 0 30px;

  h2 {
    font-size: 20px;
    font-weight: 500;
    color: #444;
    margin: 50px 0 14px;
    padding-top: 65px;
    background: url('../../assets/images/icon_dialog_warning.svg') no-repeat center top;
  }

  p {
    font-size: 14px;
    line-height: 1.5;
    color: #2f2f2f;
    margin-bottom: 40px;
  }
}
</style>
